
type Brand = {
  name: string;
  logoURL: string;
}

export class Material {
  id: string
  name: string
  description: string
  price: number
  cost: number
  quantity: number
  image: string
  // unit: string
  // unitPrice: number
  brand: Brand

  constructor () {
    this.name = ''
    this.description = ''
    this.cost = 0.00
    this.image = ''
  }
}
